import { INewFileUpload } from './new-file-upload';
import { IVersionedFile } from './versioned-file';

export interface IProfileData {
    centerId: number,
    name: string,
    webUrl: string,
    earliestOrganPickupTime: string,
    latestOrganPickupTime: string,
    timezone: string,
    avgCostLDEvalWorkup: string,
    achRoutingNumber: string,
    achAccountNumber: string,
    newAchAccountNumber: string,
    invoiceDaysToRemit: string,
    streamlinedHospitalBilling: boolean,
    physicianDonorNephrectomyCharges: string,
    provideSwapChecklists: boolean,
    canUtilizeA2toBPatients: boolean,
    w9FormPath: string,
    newW9File: INewFileUpload,
    cmsFormPath: string
    newCmsFile: INewFileUpload,
    salesTaxFile: ICenterFileType,
    isTaxExempt: boolean,
    taxExemptExpirationDate: string
    leadCoordinatorId: number
}

export interface ICenterFileType {
    typeId: number,
    type: string,
    newFile: INewFileUpload,
    files: IVersionedFile[]
}
